import { render, staticRenderFns } from "./MessagesMobile.vue?vue&type=template&id=0c39c61a&"
import script from "./MessagesMobile.vue?vue&type=script&lang=js&"
export * from "./MessagesMobile.vue?vue&type=script&lang=js&"
import style0 from "./MessagesMobile.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports